import React, { useState } from "react";
import GroupHeadDeal from "../../dashboard-util/dashboard-grouphead/group-head-deal";
import TechGroupHeadAllDealsModal from "./tech-group-head-all-deals-modal";
import { GetTechGHDealLogExcelExport } from "../../../../services/api/dashboard-api";
import PropTypes from "prop-types";
import '../dashboard-group-head-tech.scss';

const TechGroupHeadDealLog = ({ items }) => {
    const [selectedMember, setSelectedMember] = useState(null);
    const [show, setShow] = useState(false);
  
    const showModal = (project) => {
        setSelectedMember(project);
      setShow(true);
    };
  
    const onHide = () => {
        setSelectedMember(null);
      setShow(false);
    };
    const tableHeaders = ["Name", "Number of Deals", "Number of Analysts/Associates"];

    return (
      <>
        <GroupHeadDeal
          items={items}
          title="Senior Management Deal Tracker"
          departmentTitle="GIB/Technology"
          tableHeaders={tableHeaders}
          showModal={showModal}
          exportData={GetTechGHDealLogExcelExport}
          disableExport={false}
        />
        {show && selectedMember && (
          <TechGroupHeadAllDealsModal
            item={selectedMember}
            show={show}
            onHide={onHide}
          />
        )}
      </>
    );
};

TechGroupHeadDealLog.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            GroupHeadName: PropTypes.string.isRequired,
            NumberOfDeals: PropTypes.number.isRequired,
            NumberOfAnalystsAssociates: PropTypes.number.isRequired,
            Projects: PropTypes.arrayOf(PropTypes.shape({
                GroupHeads: PropTypes.arrayOf(PropTypes.shape({
                    Name: PropTypes.string,
                })),
                Members: PropTypes.arrayOf(PropTypes.shape({
                    Name: PropTypes.string,
                    Email: PropTypes.string,
                    UserName: PropTypes.string,
                    Department: PropTypes.string,
                })),
                ProjectId: PropTypes.number,
                ProjectName: PropTypes.string
            }))
        }).isRequired
    ).isRequired,
};

export default React.memo(TechGroupHeadDealLog);
